/* Angular Component */
import { Component, OnInit, SimpleChanges } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ExternalMAMGatewayProvider } from "app/js/src/domain/external-mam/external-mam-gateway-provider";
import ExternalMAMMetadataItem from "app/js/src/domain/external-mam/external-mam-metadata-item";
import { ExternalMAMServiceProvider } from "app/js/src/domain/external-mam/external-mam-service-provider";
import { IExternalMAMRepository } from "app/js/src/domain/external-mam/i-external-mam.repository";
import { UserService } from "app/js/src/domain/user-service";
import { ToastrService } from "ngx-toastr";
@Component({
  selector: "external-mam-providers-setup-layout",
  templateUrl: "./external-mam-providers-setup-layout.component.html",
  styleUrls: ["./external-mam-providers-setup-layout.component.scss"],
})
export class ExternalMAMProvidersSetupLayoutComponent implements OnInit {
  serviceProvider: ExternalMAMServiceProvider = null;
  gatewayProvider: ExternalMAMGatewayProvider = null;
  steps: Array<string> = ["connect platform", "map fields"];
  currentStep: string;
  systemLanguages: [{ name: string; code: string }];
  gatewayProviderMetadata: Array<ExternalMAMMetadataItem>;
  constructor(
    private _repository: IExternalMAMRepository,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private toastr: ToastrService,
  ) {}

  async ngOnInit() {
    const currentUser = this.userService.getCurrentUser();
    this.systemLanguages = currentUser.languages;
    this.currentStep = this.steps[0];
    this.route.params.subscribe(async (params: Params) => {
      if (!!params["id"] && !!params["name"]) {
        const [gp, metadata] = await this._repository.getGatewayProviderById(
          params["id"],
        );
        if (gp === null) {
          this.router.navigate(["/external-mam"]);
        }
        this.gatewayProviderMetadata = metadata;
        gp.mergeMetadata(currentUser.metadata);
        this.serviceProvider = await this._repository.getServiceProviderByName(
          params["name"],
        );
        if (this.serviceProvider === null) {
          this.router.navigate(["/external-mam"]);
        }
        this.gatewayProvider = gp;
      } else if (!!params["name"]) {
        this.serviceProvider = await this._repository.getServiceProviderByName(
          params["name"],
        );
        if (this.serviceProvider === null) {
          this.router.navigate(["/external-mam"]);
        }
        let gatewayProvider =
          ExternalMAMGatewayProvider.FreshExternalMAMGatewayProvider(
            this.serviceProvider.id,
          );
        gatewayProvider.setMetadata(currentUser.metadata);
        this.gatewayProvider = gatewayProvider;
        this.updateSubtitles(this.systemLanguages);
        this.updateLanguages(this.systemLanguages);
      } else {
        this.router.navigate(["/external-mam"]);
      }
    });
  }
  previousStep() {
    let i = this.steps.findIndex((x) => x == this.currentStep);
    if (i > 0) {
      this.currentStep = this.steps[i - 1];
    }
  }
  nextStep() {
    let i = this.steps.findIndex((x) => x == this.currentStep);
    if (i < this.steps.length - 1) {
      this.currentStep = this.steps[i + 1];
    }
  }
  async upsert() {
    let res;
    let state = "create";
    try {
      if (this.gatewayProvider.id) {
        state = "update";
        res = await this._repository.update(this.gatewayProvider);
      } else {
        res = await this._repository.create(this.gatewayProvider);
      }

      if (res != null) {
        this.toastr.success(`External mam provider ${state}d successfully!`);
        this.router.navigate(["/external-mam"]);
      } else {
        this.toastr.error(
          `failed to ${state} external mam provider. please try again`,
        );
      }
    } catch {
      this.toastr.error(
        `failed to ${state} external mam provider. please try again`,
      );
    }
  }
  async update() {
    var res = await this._repository.update(this.gatewayProvider);
    if (res != null) {
      this.router.navigate(["/external-mam"]);
    }
  }

  updateLoginField(e: { key: string; value: string }) {
    if (this.gatewayProvider.AbleToLogin()) {
      this.gatewayProvider.resetLogin();
    }
    this.gatewayProvider.updateLoginData(e.key, e.value);
  }
  updateSubtitles(subtitles) {
    if (subtitles && subtitles.length == 0) {
      this.gatewayProvider.updateSubtitles([]);
    } else {
      this.gatewayProvider.updateSubtitles(subtitles.map((x) => x.code));
    }
  }
  updateLanguages(languages) {
    if (languages && languages.length == 0) {
      this.gatewayProvider.updateLanguages([]);
    } else {
      this.gatewayProvider.updateLanguages(languages.map((x) => x.code));
    }
  }
  rebuildSelectedLanguages(arr: string[]): string[] {
    if (arr && arr.length === 0) {
      return [];
    }
    const r = this.systemLanguages.filter((x) => arr.includes(x.code));
    return r.map((x) => x.code);
  }
  updateMetadataMapping(e: { key: string; value: string }) {
    this.gatewayProvider.updateMetadata(e.key, e.value);
  }
  updateReferenceFields(e: Array<string>) {
    this.gatewayProvider.updateReferenceFields(e);
  }
  updateGeneralField(e: { key: string; value: string }) {
    this.gatewayProvider.updateGeneral(e.key, e.value);
  }
  updateDropBucketField(e: { key: string; value: string }) {
    this.gatewayProvider.updateDropBucket(e.key, e.value);
  }
  updateIsActive(state: boolean) {
    this.gatewayProvider.isActive = state;
  }
  async startTestConnnection() {
    if (await this._repository.testConnection(this.gatewayProvider)) {
      this.gatewayProvider.loginSuccessful();
      let metadatas = await this._repository.getMetadata(this.gatewayProvider);
      this.gatewayProviderMetadata = [...metadatas];
    } else {
      // failed to login.....
    }
  }
}
